const timerDefaults = {
    INCREMENT_STEP: 5
};

export default timerDefaults;


// WEBPACK FOOTER //
// ./src/constants/TimerDefaults.js